module.exports = __webpack_public_path__ + "img/icon43.b4d764d8.png";